import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { filterDuplicate } from '../utils/filter';

const ReferenceList = ({
  validators,
  onSelectedCode,
  selectedCode,
}) => (
  <ul className="list">
    {_.map(validators, (code, key) => {
      const fields = filterDuplicate(code.fields, 'order');
      const helpers = fields.map(field => `[${field.name}]`).join(' ');
      const liClass = selectedCode === code.start_code ? 'list__item--active' : '';
      return (
        <li
          key={key}
          className={`list__item ${liClass}`}
          role="menuitem"
          onKeyPress={() => {}}
          onClick={() => onSelectedCode(`${code.start_code}`)}
        >
          <div className="list__description">
            <p className="list__description-code">
              {`${code.start_code} - ${code.name}`}
            </p>
            <p className="list__description-detail">
              {`${code.start_code} ${helpers}`}
            </p>
          </div>
        </li>
      );
    })}
  </ul>
);

ReferenceList.defaultProps = {
  selectedCode: '',
};
ReferenceList.propTypes = {
  validators: PropTypes.shape({
    name: PropTypes.string,
    start_code: PropTypes.string,
  }).isRequired,
  selectedCode: PropTypes.string,
  onSelectedCode: PropTypes.func.isRequired,

};

export default ReferenceList;
